const BreadCrumb = ({ items }) => {
  return null;
};

export default BreadCrumb;
